import { TPartnerProgramCode } from 'legacy/lut/classes/models/SearchItem'

import { arrayUnique } from 'core/classes/helpers/Helper'

export function getPartnerCodes(programCodes: string[]): TPartnerProgramCode[] {
  const result: TPartnerProgramCode[] = []

  arrayUnique(programCodes).forEach((programCode) => {
    if (programCode.match(/^G_PM_PF_(.*)_PAR_HW$/)) {
      result.push('P1 HW')
    }

    if (programCode.match(/^G_PM_PF_(.*)_PAR_SUP$/)) {
      result.push('P1 Sup')
    }

    if (programCode.match(/^G_SPEC_PF_(.*)/)) {
      result.push('P1 Spec')
    }
    if (programCode === 'G_PM_PF_BUS_PAR') {
      result.push('BP')
    }
    if (programCode === 'EU-PPS-C001') {
      result.push('Ret H1')
    }
    if (programCode === 'EU-PPS-C003') {
      result.push('Ret H2')
    }
    if (programCode === 'EU-DI-PSG-SBSO-BLACKLIST') {
      result.push('BP banned')
    }
  })

  return arrayUnique(result)
}
